import { render, staticRenderFns } from "./ApprovalItem.vue?vue&type=template&id=688c9185&scoped=true"
import script from "./ApprovalItem.vue?vue&type=script&lang=js"
export * from "./ApprovalItem.vue?vue&type=script&lang=js"
import style0 from "./ApprovalItem.vue?vue&type=style&index=0&id=688c9185&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688c9185",
  null
  
)

export default component.exports